import { useContext } from 'react';
import ConfigurationContext from 'context/Configuration/Context';

const useConfiguration = () => useContext(ConfigurationContext) || {};

export default useConfiguration;
